import { config } from 'src/config/config'
import { apiCall } from 'src/utils/networking'

export const api = {
  getPublicSpaces: async ({ page = 1 }) =>
    apiCall(`${config.baseAPIUrl}/space/list/?page=${page}&limit=50`, {
      method: 'POST',
    }),
}
